import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Heading, P, SectionWrapper } from '../../Styles/style'
import chart from '../../../assets/chart.png'
import uniswap from '../../../assets/uniswap.png'
import ethscan from '../../../assets/ethscan.png'
import colorbg from '../../../assets/colorbg.png'
import styled from '@emotion/styled'

const WhyWrapper = styled.div`
background-image: url(${colorbg});

`

const Products = () => {
  return (
    <SectionWrapper p="3.5rem 0 0 0" m="1.5rem 0 0 0" id="products">
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
          </Grid>
          <Grid item xs={12} sm={4} style={{textAlign: 'center', padding: '0.5rem 0'}}>
            <img src={chart} alt="products" style={{width:'100%', height: 'auto', maxWidth:'180px', marign: 'auto'}} />
          </Grid>
          <Grid item xs={12} sm={4} style={{textAlign: 'center', padding: '0.5rem 0'}}>
            <img src={uniswap} alt="products" style={{width:'100%', height: 'auto', maxWidth:'180px', marign: 'auto'}} />
          </Grid>
          <Grid item xs={12} sm={4} style={{textAlign: 'center', padding: '0.5rem 0'}}>
            <img src={ethscan} alt="products" style={{width:'100%', height: 'auto', maxWidth:'180px', marign: 'auto'}} />
          </Grid>
        </Grid>
      </Container>
    </SectionWrapper>
  )
}

export default Products